// Shared, gentle distress check used by chat and Let Go (client) and the server.
// Plain data, no React, so server.ts can import it too.

// English, then a few other languages people use on Zuzu (Hindi, Hinglish,
// Spanish, French, Arabic, Chinese). A gentle hint only; it never blocks anything.
export const CRISIS_RE = new RegExp([
  "suicid", "kill (myself|my ?self)", "end (my life|it all)", "self[-\\s]?harm", "hurt(ing)? myself", "cut(ting)? myself",
  "want to die", "wanna die", "better off dead", "no reason to live",
  "(don'?t|do not)( really)?( think i)? want to (live|be here|exist|wake up)", "want to be here anymore",
  "(don'?t|can'?t) see the point (of|in) (living|life|anything|going on)", "can'?t go on",
  // Hindi and Hinglish
  "marna chaht", "mar jana chaht", "jeena nahi chaht", "jeene ka mann nahi", "khudkushi", "जीना नहीं", "मरना चाहत", "मर जाना चाहत", "आत्महत्या", "खुदकुशी",
  // Spanish, French, Arabic, Chinese
  "quiero morir", "no quiero vivir", "me quiero matar", "envie de mourir", "me suicider", "plus envie de vivre",
  "أريد أن أموت", "انتحار", "想死", "自杀", "不想活",
].join("|"), "i");

export const looksLikeCrisis = (text: string) => CRISIS_RE.test(text);

// findahelpline.com lists free, confidential helplines for every country.
export const HELPLINE_URL = 'https://findahelpline.com';

export const REPORT_REASONS = [
  { key: 'harassment', label: 'Rude or harassing' },
  { key: 'sexual', label: 'Sexual or inappropriate' },
  { key: 'hate', label: 'Hate or threats' },
  { key: 'spam', label: 'Spam or scam' },
  { key: 'other', label: 'Something else' },
] as const;

export type ReportReason = typeof REPORT_REASONS[number]['key'];
